import { FormHelperText } from '@mui/material';
import { theme } from '@src/theme';

export const ErrorHelperText = ({ error }) => {
  return (
    <FormHelperText
      sx={{
        order: '-1',
        height: 0,
        color: theme.palette.error['200'],
      }}
    >
      {error}
    </FormHelperText>
  );
};
